import { Injectable, EventEmitter } from '@angular/core';

import { ScriptMetaData } from '../dataModels';
import { forEach } from '@angular/router/src/utils/collection';

@Injectable()
export class ScriptLoader {

    loadedScript: string[] = [];

    public loadScript(metaData: ScriptMetaData): void {

        //Create Script Element
        const script = this.creatScript(metaData);

        //Hook on load Event
        script.onload = (eve) => {

            //Emit On Script Loaded
            metaData.onScriptLoaded.emit(eve);
        };

        //Append to Body
        document.body.appendChild(script);

    }

    public loadBundle(metaDataList: ScriptMetaData[]): void {

        //Is exist
        if (metaDataList && metaDataList.length > 0) {

            //Script Element Reference
            var scriptList: HTMLElement[] = [];

            //count number of scripts loaded
            var counter: number;

            //for each member in meta data list
            for (var metaData of metaDataList) {

                // get the script name
                var fileNameSplited = metaData.source.split('/')
                var fileName = fileNameSplited[fileNameSplited.length - 1];

                var isScriptloaded = false;

                // check if the script is already loaded
                this.loadedScript.forEach(loadedScript => {
                    if (loadedScript.indexOf(fileName) >= 0) {
                        isScriptloaded = true; // script is loaded
                        return;
                    }
                });
                
                if (!isScriptloaded) {
                    //create script element
                    var script = this.creatScript(metaData);

                    //on script loaded
                    script.onload = (eve) => {

                        //increament
                        counter++;

                        //all done loading
                        if (counter == scriptList.length) {
                            //Emit On Script Loaded
                            metaData.onScriptLoaded.emit(eve);
                        }
                    };

                    //add to script list
                    scriptList.push(script);

                    //Append to Body
                    document.body.appendChild(script);

                    //Add to loaded Scripts
                    this.loadedScript.push(metaData.source);
                }
            }
        }
    }

    private creatScript(metaData: ScriptMetaData): HTMLElement {

        //new Script Element
        const script = document.createElement('script');

        //set type to Java Script
        script.type = 'text/javascript';

        //set Async
        script.async = metaData.isAsync;

        //set Defer
        script.defer = metaData.isDefer;

        //set Source
        script.src = metaData.source;

        return script;
    }
} 


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/script-loader.service.ts